import React from "react";


const GoogleMap = () => {
  return (
    <div className="googleMapContainer">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.322866775594!2d80.1430586!3d12.9511801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525e52ecc49e6d%3A0xfb0208d2733213e4!2sDinesh%20Builders%20%26%20furnishers!5e0!3m2!1sen!2sin!4v1742125955836!5m2!1sen!2sin"
        className="googleMap"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
      ></iframe>
    </div>
  );
};

export default GoogleMap;
